<script>
export default {
  name: 'DialogBackButton',
  props: {
    backMethod: {
      type: Function,
      required: true
    }
  }
}
</script>

<template>
  <button type="button" class="dialog-back-btn" @click="backMethod()">
    <v-icon icon="mdi-arrow-left" size="20" />
  </button>
</template>

<style scoped>
.dialog-back-btn {
  position: absolute;
  top: 32px;
  left: 32px;
}
</style>
